module.exports = __webpack_public_path__ + "img/user-status.a0124e9a.svg";